const steps = [
  { num: "01", title: "Apply Online", desc: "Submit your company details and get started" },
  { num: "02", title: "Setup Your Sites", desc: "Add your security sites and zones" },
  { num: "03", title: "Configure Checkpoints", desc: "Choose GPS geofence or QR code per checkpoint" },
  { num: "04", title: "Officers Log In", desc: "Secure shift-rotating password authentication" },
  { num: "05", title: "Patrol & Verify", desc: "Face scan + GPS/QR dual verification" },
  { num: "06", title: "Owners Monitor Live", desc: "Real-time dashboards at every level" },
];

const HowItWorksSection = () => (
  <section id="how-it-works" className="py-24">
    <div className="mx-auto max-w-7xl px-6">
      <p className="text-sm font-semibold tracking-widest text-primary">How It Works</p>
      <h2 className="mt-2 text-3xl font-bold md:text-5xl">6 STEPS TO SECURE OPERATIONS</h2>
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {steps.map((s, i) => (
          <div key={s.num} className="rounded-xl border border-border bg-card p-8 animate-fade-in" style={{ animationDelay: `${i * 0.1}s`, animationFillMode: "backwards" }}>
            <span className="text-4xl font-bold text-primary/30">{s.num}</span>
            <h3 className="mt-3 text-lg font-bold">{s.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorksSection;
